<template>
  <div class="order-page">
    <!-- 顶部悬浮栏：包含日期选择和提示 -->
    <van-sticky @scroll="stickyChange">
      <!-- 日期查询头部 -->
      <van-cell size="large" class="glass-header">
        <template #title>
          <span style="font-size: 12px;color: #969799;">分润 = 销售价-结算成本</span>
        </template>
      </van-cell>
    </van-sticky>

    <!-- 核心列表：包含下拉刷新和上拉加载 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
        <!-- 订单卡片循环渲染 -->
        <div class="content-wrapper" v-for="(item, index) in list"
          :key="item.iccid + '-' + (item.recharge_id || item.addflow_id || index)">
          <div class="box">
            <!-- 卡号与订单头部 -->
            <div class="title">
              <div class="methodTitle">
                <h3 class="label">{{ formatICCID(item.iccid) }}</h3>
              </div>
              <!-- 套餐详情列表 -->
              <div class="methodSlidebt">
                <ul>
                  <li>
                    <h3>套餐名称</h3>
                    <p>{{ item.pk_name }}</p>
                  </li>
                  <li>
                    <h3>流量</h3>
                    <p>{{ item.flow }}MB</p>
                  </li>
                  <li>
                    <h3>售价</h3>
                    <p>{{ item.recharge_amount > 0 ? item.recharge_amount + '元' : '-' }}</p>
                  </li>
                  <li>
                    <h3>分润</h3>
                    <p>{{ item.profit_amount > 0 ? item.profit_amount + '元' : '-' }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="zwf"></div>
        </div>
      </van-list>
    </van-pull-refresh>

    <!-- 日期选择弹窗 -->
    <van-action-sheet v-model="orderDate.isSelect">
      <van-datetime-picker v-model="czCurrentDate" type="date" title="选择年月日" @confirm="getTime"
        @cancel="orderDate.isSelect = false" />
    </van-action-sheet>
  </div>
</template>

<script>
// --- 模拟 API 请求 (预留接口) ---
// 在实际项目中，这里应引入真实的 API 方法
const fetchOrderData = (params) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // 模拟数据生成逻辑
      const mockData = {
        code: 0, // 模拟成功状态
        extend: {
          rows: [],
          total: 0
        }
      }

      const {
        page,
        limit,
        endRechargeDate
      } = params
      const startId = (page - 1) * limit + 1

      for (let i = 0; i < limit; i++) {
        const id = startId + i
        mockData.extend.rows.push({
          iccid: `套餐 ${String(id + 10000000).slice(-8)}`,
          recharge_id: `ORD${Date.now()}${id}`,
          recharge_date: endRechargeDate || '2026-06-06',
          pk_name: ['100MB测试包', '1GB月包', '5GB周包', '200MB日包'][id % 4],
          flow: [100, 1024, 5120, 200][id % 4],
          recharge_amount: [5, 15, 40, 2][id % 4],
          profit_amount: [1, 3, 7, 0.5][id % 4],
          addflow_id: null
        })
      }

      // 模拟分页结束 (假设只有 25 条数据)
      if (startId > 25) {
        mockData.extend.rows = []
      }

      resolve({
        data: mockData
      })
    }, 800)
  })
}

export default {
  name: 'IntegratedOrderPage',
  data () {
    return {
      // 列表状态
      loading: false,
      finished: false,
      refreshing: false,

      // 日期选择器
      orderDate: {
        isSelect: false
      },
      czCurrentDate: new Date(),

      // 请求参数 (模拟)
      paramsList: {
        token: 'mock_token_123', // 模拟 token
        userId: 'user_1',
        page: 1,
        limit: 10,
        endRechargeDate: ''
      },

      // 列表数据
      list: [],

      // 悬浮栏样式控制
      stickyChangeFlag: false
    }
  },
  methods: {
    // 格式化 ICCID 显示 (4位一分隔)
    formatICCID (iccid) {
      if (!iccid) return ''
      return String(iccid).match(/.{1,4}/g).join(' ')
    },

    // 模拟复制功能 (实际项目中需引入 copy 库)
    formatCopy (iccid) {
      // 这里仅做演示，实际应使用 document.execCommand 或第三方库
      alert(`已复制 ICCID: ${iccid}`)
    },

    // 打开日期选择
    openTimeChanges () {
      this.orderDate.isSelect = true
    },

    // 确认选择日期
    getTime (val) {
      this.paramsList.page = 1
      this.paramsList.endRechargeDate =
          `${val.getFullYear()}-${String(val.getMonth() + 1).padStart(2, '0')}-${String(val.getDate()).padStart(2, '0')}`
      this.orderDate.isSelect = false
      this.getList()
    },

    // 重置查询
    replay () {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否重置查询时间'
      }).then(() => {
        this.rechargeReplay()
      }).catch(() => {
        this.$toast('取消重置')
      })
    },

    // 重置逻辑
    rechargeReplay () {
      this.czCurrentDate = new Date()
      this.paramsList.endRechargeDate = ''
      this.paramsList.page = 1
      this.getList()
    },

    // 悬浮栏滚动事件
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    },

    // 获取列表数据 (核心方法)
    async getList () {
      try {
        const res = await fetchOrderData(this.paramsList)

        // 模拟登录失效检查
        if (res.data.msg && res.data.msg.includes('请重新登录')) {
          this.$toast && this.$toast.fail('请重新登录')
          return
        }

        const rows = res.data.extend?.rows || []

        if (this.refreshing) {
          // 下拉刷新：替换数据
          this.list = rows
          this.refreshing = false
        } else {
          // 上拉加载：追加数据
          this.list = this.list.concat(rows)
        }

        // 判断是否还有更多
        if (rows.length < this.paramsList.limit) {
          this.finished = true
        } else {
          this.paramsList.page++
        }
      } catch (err) {
        console.error(err)
        if (this.refreshing) this.refreshing = false
        if (!this.refreshing && !this.finished) this.loading = false
      }
    },

    // 下拉刷新触发
    onRefresh () {
      this.paramsList.page = 1
      this.finished = false
      this.getList()
    },

    // 上拉加载触发
    loadMore () {
      this.getList()
    }
  },
  mounted () {
    // 页面加载时获取数据
    this.getList()
  }
}
</script>

<style scoped lang="less">
  // --- 样式部分 ---
  // 为了保持代码完整性，保留了主要的样式定义

  .glass-header {
    padding-top: 10px;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background: linear-gradient(to bottom, rgba(237, 237, 237, 1) 10%, rgba(247, 247, 247, 0.9) 50%, rgba(247, 247, 247, 0.7) 90%, rgba(247, 247, 247, 0) 100%);
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
    z-index: 100;
  }

  .box {
    max-width: 80%;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 0.08);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .methodTitle {
    display: flex;
    justify-content: space-between;
    padding: 30px 0 0 40px;

    h3 {
      font-size: 30px;
      color: #838383;
      line-height: 20px;
      font-weight: 400;
    }

    .label {
      flex: 1;
      width: 150px;
    }

    .value {
      flex: 2;
    }
  }

  .methodSlidebt {
    padding: 30px 40px 0;

    ul {
      display: flex;
      justify-content: space-between;
      height: 120px;

      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        h3 {
          line-height: 18px;
          font-size: 25px;
          color: #9d9da3;
        }

        p {
          line-height: 20px;
          font-size: 25px;
          color: #272729;
        }
      }
    }
  }

  .zwf {
    height: 15px;
  }
</style>
